<template>
  <main id="main">
    <SponsorDonateListForm :categorySeq = categorySeq />
  </main>
</template>
<script>
import SponsorDonateListForm from '@/components/sponsor/SponsorDonateListForm.vue';

export default {
  props: {
    categorySeq: {
      type: String,
      required: true
    },
  },
  components: {
    SponsorDonateListForm
  }
}
</script>
<style>
    
</style>